export default __webpack_public_path__ + "static/home-page-96e8bc77c07500e60f232ed9e84ab824.jpg";